import Axios from "axios";
import { API_URL } from "../../../DesktopApp";

const getCandidates = async (LIMIT, page, status) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates-status/getStatusWiseLeads`,
      { limit: LIMIT, page: page, status: status }
    );
    return response;
  } catch (err) {
    return err;
  }
};



const unSetLead = async (lead_id) => {
  try {
    const response = await Axios.post(`${API_URL}/desktop/candidates/deletecandidate`, {
      lid: lead_id,
    });
    return response;
  } catch (err) {
    return err;
  }
};

export { getCandidates, unSetLead };
